import axiosInstance from "./axiosConfig"

export const getAllPlans = async () => {
   return await axiosInstance.get('/billing/packages');
}

export const getAllInvoice = async () => {
   return await axiosInstance.get('/invoices');
}

export const getInvoiceById = async (id) => {
   return await axiosInstance.get(`/billing/invoices/${id}`)
}

export const getDownloadInvoiceById = async (id) => {
   return await axiosInstance.get(`/billing/invoices/${id}/pdf`,{responseType: 'blob'})
}

export const getAllPaymentMethods = async () => {
   return await axiosInstance.get('/payment_methods');
}

export const getPaymentCardInfo = async () => {
   return await axiosInstance.get('/billing/subscriptions/card_info');
}

export const applyCoupon = async (data) => {
   return await axiosInstance.get(`/billing/coupons/check_coupon?coupon_code=${data.coupon_code}`);
}

export const removeCoupon = async (data) => {
   return await axiosInstance.delete('/billing/coupons/remove_coupon', data, { silent: true });
}

export const getCurrentPlan = async () => {
   return await axiosInstance.get(`/billing/packages/current_plan_details?_t=${Date.now()}`)
}

export const getNextBilling = async () => {
   return await axiosInstance.get(`/subscriptions/next_billing`)
}

export const planSwitch = async (data) => {
   return await axiosInstance.post(`/billing/switch/plan_switch`, data)
}

export const paymentMethodChange = async (data) => {
   return await axiosInstance.post(`/billing/switch/switch_payment_method`, data)
}

export const cancelDowngrade = async (data) => {
   return await axiosInstance.delete(`/billing/switch/cancel_downgrade`)
}

export const upgradePlan = async (data) => {
   return await axiosInstance.post(`/subscriptions/upgrade`, data)
}

export const downgradePlan = async (data) => {
   return await axiosInstance.post(`/subscriptions/downgrade`, data)
}

export const addPaymentMethod = async (data) => {
   return await axiosInstance.post('/payment_methods', data)
}

export const updatePaymentMethod = async (methodId) => {
   return await axiosInstance.patch(`/payment_methods/${methodId}`, data)
}

export const deletePaymentMethod = async (methodId) => {
   return await axiosInstance.delete(`/payment_methods/${methodId}`)
}

export const cancelSubscription = async (data) => {
   return await axiosInstance.post(`/subscriptions/cancel`, data)
}

export const paymentStatus = async () => {
   return await axiosInstance.get(`/billing/subscriptions/autosetup_status`)
}

export const createPlan = async (data) => {
   return await axiosInstance.post(`/onboarding/checkout`, data)
}

export const previewPlanSummary = async (data) => {
   return await axiosInstance.post('/billing/subscriptions/preview', data)
}

export const addonInvoicePreview = async (marketplaceAccountId) => {
   let query = "";
   if (Array.isArray(marketplaceAccountId)) {
      query = marketplaceAccountId
         .map(id => `marketplace_account_id[]=${id}`)
         .join("&");
   }
   else {
      query = `marketplace_account_id=${marketplaceAccountId}`;
   }

   return await axiosInstance.get(`/billing/subscriptions/addon_invoice_preview?${query}`);
};


export const addonSellerAccount = async (marketplaceAccountId) => {
   const isArray = Array.isArray(marketplaceAccountId);

   let query = "";
   if (isArray) {
      query = marketplaceAccountId
         .map(id => `marketplace_account_ids[]=${id}`)
         .join("&");
   }
   else {
      query = `marketplace_account_id=${marketplaceAccountId}`;
   }
   return await axiosInstance.get(`/billing/subscriptions/addon_account?${query}`)
};


export const paymentSessionExpired = async () => {
   return await axiosInstance.get('/billing/subscriptions/cancel_payment')
}

export const reGeneratePaymentUrl = async (data) => {
   return await axiosInstance.post('/billing/switch/switch_payment_method', data)
}

export const subscriptionOverview = async () => {
   return await axiosInstance.get('/billing/subscriptions/subscription_overview')
}

export const upcomePaymentOverview = async () => {
   return await axiosInstance.get('/billing/subscriptions/preview_upcoming')
}

export const userWalletData = async () => {
   return await axiosInstance.get('/billing/wallet/wallet_data')
}

// export const userWalletHistory = async () => {
//    return await axiosInstance.get('/billing/wallet/wallet_history')
// }

export const userPoint = async () => {
   return await axiosInstance.get('/billing/points')
}

export const addWalletMoney = async (data) => {
   return await axiosInstance.post('/billing/wallet/generate_topup_link', data)
}

export const cancelSubscriptionById = async (subscriptionId, data) => {
   return await axiosInstance.patch(`/billing/subscriptions/${subscriptionId}/cancel`, data)
}

export const userPointsLedger = async () => {
   return await axiosInstance.get('/billing/points/ledger')
}

export const consumePoints = async (data) => {
   return await axiosInstance.post('/billing/points/consume', data)
}

export const generatePointsTopupLink = async (data) => {
   return await axiosInstance.post('/billing/points/generate_topup_link', data)
}
